import { render, staticRenderFns } from "./ReportSalesPerCustomerPage.vue?vue&type=template&id=38b71e08&scoped=true"
import script from "./ReportSalesPerCustomerPage.vue?vue&type=script&lang=js"
export * from "./ReportSalesPerCustomerPage.vue?vue&type=script&lang=js"
import style0 from "./ReportSalesPerCustomerPage.vue?vue&type=style&index=0&id=38b71e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b71e08",
  null
  
)

export default component.exports